// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".canvas--En3H_ZU9 {\n  position: relative;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n\n.linksLayer--1HQA0tlV,\n.nodesLayer--xUvp4YFt,\n.nodesContainer--3ZttYYIF,\n.nodeWrapper--1Spml75f {\n  position: absolute;\n}\n\n/* svg */\n.arrowMarker--1pW_pSjU path {\n  fill: #b9b9b9;\n}\n\n.link--2thIdn3Q path {\n  fill: none;\n  stroke: #b9b9b9;\n  stroke-width: 1;\n}\n\n.grabbing--1s8I9rLl {\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"canvas": "canvas--En3H_ZU9",
	"linksLayer": "linksLayer--1HQA0tlV",
	"nodesLayer": "nodesLayer--xUvp4YFt",
	"nodesContainer": "nodesContainer--3ZttYYIF",
	"nodeWrapper": "nodeWrapper--1Spml75f",
	"arrowMarker": "arrowMarker--1pW_pSjU",
	"link": "link--2thIdn3Q",
	"grabbing": "grabbing--1s8I9rLl"
};
export default ___CSS_LOADER_EXPORT___;
